export default class IntegrationFieldValueModel {
  id!: number;

  label!: string;

  key!: string;

  valor!: string | null;
}
